import http, { HttpSuccessOrErrorType } from '../http';
import { Admin, ResultSetHeader } from '../../models';
import { AxiosRequestConfig } from 'axios';

export default {
    /**
     * 查询单个Admin资源。
     * @param params 参数
     */
    async get_admin_id_id(_id: string, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<Admin | null>> {
        return await http.get(`/admin/_id/${_id}`, {
            ...config
        })
    },

    /**
     * 修改admin账号信息
     * @param params 参数
     */
    async patch_admin_id_admin(params: Admin, config?: AxiosRequestConfig):
        Promise<HttpSuccessOrErrorType<any>> {
        const { _id, ...rest } = params;
        return await http.patch(`/admin/_id/${_id}/admin`, {
            ...rest
        }, config)
    },

    /**
     * 管理员上传头像。
     */
    async patch_admin_id_avatar(_id: string, params: any, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        // $ 将图片转为2进制数据
        const formData = new FormData();
        formData.append('', params);
        return (
            await http.patch(`/admin/_id/${_id}/avatar`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                ...config
            })
        );
    },

    /**
     * 查询头像
     * @param params 参数
     */
    async get_admin_id_avatar(id?: string, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        return await http.get(`/admin/${id}/avatar`, {
            ...config
        })
    },

    /**
     * 修改密码
     * @param params 参数
     */
    async patch_admin_password_current(params: { _id: string, currentPassword: string, newPassword: string }, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        return await http.patch(`/admin/password/current`, {
            ...params
        }, {
            ...config
        })
    }
}